/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {useEffect, useState} from 'react';

const CmdIndexTabla = ({listItemCmd}) => {
  
  
  const [isActive, setIsActive] = useState(false);
  
  useEffect(() => {
    setIsActive(false);
  }, [])
  
  const cssClass = "dropdown " + (isActive ? "is-active" : "");
  
  if (listItemCmd.length === 0) {
    return null;
  }
  
  const listItem = listItemCmd.map((k, indexK) => {
    
    if (k === "sep") {
      return <hr key={indexK + 1} className="m0"/>
    }
    const onClick = () => {
      setIsActive(false);
      k.fn();
    }
  
    return (
      <a href="#" className="dropdown-item" key={indexK + 1} onClick={onClick}>
        {k.item}
      </a>
    );
  });
  
  return (
    <div className={cssClass}>
      
      <div className="dropdown-trigger">
        <button className="button is-primary"
                onClick={() => setIsActive(!isActive)}
                aria-haspopup="true" aria-controls="dropdown-menu">
    
          <i className="fa fa-cogs"/>
          <span className="icon is-small">
              <i className="fa fa-angle-down" aria-hidden="true"/>
         </span>
  
        </button>
      </div>
      <div className="dropdown-menu" id="dropdown-menu" role="menu">
        <div className="dropdown-content" onMouseLeave={() => {
          return isActive ? setIsActive(false) : null
        }}>
          {listItem}
        </div>
      </div>
    </div>
  );
};

export default CmdIndexTabla